module.exports = "/static/_/generated/images/GovCloud_300x169_transparent.png?a1fd7cd6ceb70895023dc248d59e233f";